module.exports = __webpack_public_path__ + "static/pink1-38f61b48f04450332fbb8b32f30cdf2f.png";